import React from "react";
import logo from "../../../assets/logo.png";

export const AdminHeader = () => {
  return (
    <div>
      <a className="navbar-brand" href="/">
        <img src={logo} width="100%" height="100%" alt="logo" />
      </a>
    </div>
  );
};
